export default __webpack_public_path__ + "static/N0091-6ec2e5b30a08f8c3463a12d6fb600bc0.png";